import { Dispatch } from "react";
import * as actionTypes from "../actionTypes/Index";
import {
  IActionType,
  IProductCategory,
  IGetQueryParams,
  IWarehousePayload,
  INormalizedProductCityLevelInventory,
  IProductCityLevelInventoryPayload,
  IOdooTaxResponse,
  IOdooTaxListResponse,
} from "../../interfaces/Index";
import {
  fetchProductCityLevelsApiCall,
  fetchProductCityLevelBrandApiCall,
  productCityLevelFetchWareHouseNamesApiCall,
  fetchProductCityLevelInventoryApiCall,
  updateProductCityLevelInventoryApiCall,
} from "../sources/ProductCityLevelSource";
import {
  multiPartUploadApiCall,
  fetchOdooTaxApiCall,
} from "../sources/GlobalProductSource";

export const fetchProductCityLevelInit = () => ({
  type: actionTypes.GET_PRODUCTS_CITY_LEVEL_INIT,
});

export const fetchProductCityLevelSuccess = (payload: Array<any> | null) => ({
  type: actionTypes.GET_PRODUCTS_CITY_LEVEL_SUCCESS,
  payload,
});

export const fetchProductCityLevelFail = (error: string | object | null) => ({
  type: actionTypes.GET_PRODUCTS_CITY_LEVEL_FAIL,
  error,
});

export const clearProductCityLevelDetails = () => ({
  type: actionTypes.CLEAR_PRODUCT_CITY_LEVEL_DETAILS,
});

export const productCityLevelBulkUploadInit = () => ({
  type: actionTypes.BULK_UPLOAD_INIT,
});

export const productCityLevelBulkUploadSuccess = () => ({
  type: actionTypes.BULK_UPLOAD_SUCCESS,
});

export const productCityLevelBulkUploadFail = (
  error: string | object | null
) => ({
  type: actionTypes.BULK_UPLOAD_FAIL,
  error,
});

export const productCityLevelInventoryUploadInit = () => ({
  type: actionTypes.INVENTORY_UPLOAD_INIT,
});

export const productCityLevelInventoryUploadSuccess = () => ({
  type: actionTypes.INVENTORY_UPLOAD_SUCCESS,
});

export const productCityLevelInventoryUploadFail = (
  error: string | object | null
) => ({
  type: actionTypes.INVENTORY_UPLOAD_FAIL,
  error,
});

export const newProductCityLevelPriceUploadInit = () => ({
  type: actionTypes.NEW_CITY_LEVEL_PRODUCT_PRICE_UPLOAD_INIT,
});

export const newProductCityLevelPriceUploadSuccess = () => ({
  type: actionTypes.NEW_CITY_LEVEL_PRODUCT_PRICE_UPLOAD_SUCCESS,
});

export const newProductCityLevelPriceUploadFail = (
  error: string | object | null
) => ({
  type: actionTypes.NEW_CITY_LEVEL_PRODUCT_PRICE_UPLOAD_FAIL,
  error,
});

export const getProductCityLevelBrandInit = () => ({
  type: actionTypes.GET_PRODUCT_CITY_LEVEL_BRANDS_INIT,
});

export const getProductCityLevelBrandSuccess = (payload: Array<any>) => ({
  type: actionTypes.GET_PRODUCT_CITY_LEVEL_BRANDS_SUCCESS,
  payload,
});

export const getProductCityLevelBrandFail = (
  error: string | object | null
) => ({
  type: actionTypes.GET_PRODUCT_CITY_LEVEL_BRANDS_FAIL,
  error,
});

export const getWareHouseNamesInit = () => ({
  type: actionTypes.GET_WAREHOUSE_INIT,
});

export const getWareHouseNamesSuccess = (
  payload: Array<IWarehousePayload>
) => ({
  type: actionTypes.GET_WAREHOUSE_SUCCESS,
  payload,
});

export const getWareHouseNamesFail = (error: string | object | null) => ({
  type: actionTypes.GET_WAREHOUSE_FAIL,
  error,
});

export const getProductCityLevelInventoryInit = () => ({
  type: actionTypes.GET_PRODUCT_CITY_LEVEL_INVENTORY_INIT,
});

export const getProductCityLevelInventorySuccess = (
  payload: Array<INormalizedProductCityLevelInventory>
) => ({
  type: actionTypes.GET_PRODUCT_CITY_LEVEL_INVENTORY_SUCCESS,
  payload,
});

export const getProductCityLevelInventoryFail = (
  error: string | object | null
) => ({
  type: actionTypes.GET_PRODUCT_CITY_LEVEL_INVENTORY_FAIL,
  error,
});

export const productCityLevelInventoryUpdateInit = () => ({
  type: actionTypes.UPDATE_PRODUCT_CITY_LEVEL_INVENTORY_INIT,
});

export const productCityLevelInventoryUpdateSuccess = () => ({
  type: actionTypes.UPDATE_PRODUCT_CITY_LEVEL_INVENTORY_SUCCESS,
});

export const productCityLevelInventoryUpdateFail = (
  error: string | object | null
) => ({
  type: actionTypes.UPDATE_PRODUCT_CITY_LEVEL_INVENTORY_FAIL,
  error,
});

export const getOdooTaxInit = () => ({
  type: actionTypes.GET_ODOO_TAX_INIT,
});

export const getOdooTaxSuccess = (
  payload: IOdooTaxListResponse[] | IOdooTaxResponse
) => ({
  type: actionTypes.GET_ODOO_TAX_SUCCESS,
  payload,
});

export const getOdooTaxFail = (error: string | object | null) => ({
  type: actionTypes.GET_ODOO_TAX_FAIL,
  error,
});

// async actions

export const getProductCityLevels =
  (cityId: string, queryParams?: IGetQueryParams) =>
  (dispatch: Dispatch<IActionType>) => {
    dispatch(fetchProductCityLevelInit());
    return fetchProductCityLevelsApiCall(cityId, queryParams)
      .then((productCityLevels: any) =>
        dispatch(fetchProductCityLevelSuccess(productCityLevels))
      )
      .catch((e: object | null | string) =>
        dispatch(fetchProductCityLevelFail(e))
      );
  };

export const bulkUploadProductCityLevel =
  (payload: FormData, url: string) => (dispatch: Dispatch<IActionType>) => {
    dispatch(productCityLevelBulkUploadInit());
    return multiPartUploadApiCall(payload, url)
      .then(() => dispatch(productCityLevelBulkUploadSuccess()))
      .catch((e: object | null | string) =>
        dispatch(productCityLevelBulkUploadFail(e))
      );
  };

export const inventoryUploadProductCityLevel =
  (payload: FormData, url: string) => (dispatch: Dispatch<IActionType>) => {
    dispatch(productCityLevelInventoryUploadInit());
    return multiPartUploadApiCall(payload, url)
      .then(() => dispatch(productCityLevelInventoryUploadSuccess()))
      .catch((e: object | null | string) =>
        dispatch(productCityLevelInventoryUploadFail(e))
      );
  };

export const newProductCityLevelPriceUpload =
  (payload: FormData, url: string) => (dispatch: Dispatch<IActionType>) => {
    dispatch(newProductCityLevelPriceUploadInit());
    return multiPartUploadApiCall(payload, url, false)
      .then(() => dispatch(newProductCityLevelPriceUploadSuccess()))
      .catch((e: object | null | string) =>
        dispatch(newProductCityLevelPriceUploadFail(e))
      );
  };

export const clearProductCityLevelDetailsAction =
  () => (dispatch: Dispatch<IActionType>) => {
    return dispatch(clearProductCityLevelDetails());
  };

export const fetchProductCityLevelBrands =
  () => (dispatch: Dispatch<IActionType>) => {
    dispatch(getProductCityLevelBrandInit());
    return fetchProductCityLevelBrandApiCall()
      .then((productCityLevelBrands: Array<IProductCategory>) =>
        dispatch(getProductCityLevelBrandSuccess(productCityLevelBrands))
      )
      .catch((e: object | null | string) =>
        dispatch(getProductCityLevelBrandFail(e))
      );
  };

export const productCityLevelFetchWareHouseNames =
  (requestParam: any) => (dispatch: Dispatch<IActionType>) => {
    dispatch(getWareHouseNamesInit());
    return productCityLevelFetchWareHouseNamesApiCall(requestParam)
      .then((wareHouseNames: Array<IWarehousePayload>) =>
        dispatch(getWareHouseNamesSuccess(wareHouseNames))
      )
      .catch((e: object | null | string) => dispatch(getWareHouseNamesFail(e)));
  };

export const fetchProductCityLevelInventory =
  (id: string, queryParam: any) => (dispatch: Dispatch<IActionType>) => {
    dispatch(getProductCityLevelInventoryInit());
    return fetchProductCityLevelInventoryApiCall(id, queryParam)
      .then((productInventory: INormalizedProductCityLevelInventory[]) =>
        dispatch(getProductCityLevelInventorySuccess(productInventory))
      )
      .catch((e: object | null | string) =>
        dispatch(getProductCityLevelInventoryFail(e))
      );
  };

export const updateProductCityLevelInventory =
  (id: string, payload: IProductCityLevelInventoryPayload) =>
  (dispatch: Dispatch<IActionType>) => {
    dispatch(productCityLevelInventoryUpdateInit());
    return updateProductCityLevelInventoryApiCall(id, payload)
      .then(() => dispatch(productCityLevelInventoryUpdateSuccess()))
      .catch((e: object | null | string) =>
        dispatch(productCityLevelInventoryUpdateFail(e))
      );
  };

export const productCityLevelFetchTaxFromOdoo =
  (id: string = "") =>
  (dispatch: Dispatch<IActionType>) => {
    dispatch(getOdooTaxInit());
    return fetchOdooTaxApiCall(id)
      .then((tax: IOdooTaxListResponse[] | IOdooTaxResponse) =>
        dispatch(getOdooTaxSuccess(tax))
      )
      .catch((e: object | null | string) => dispatch(getOdooTaxFail(e)));
  };
